module.exports = __webpack_public_path__ + "img/img_dingdan.ec944ff2.png";